import React from 'react';
import RPD from './RPD';

function RpdContainer({updateStatus}) {
  return <RPD updateStatus={updateStatus} />;
}

export default RpdContainer;
